import {
  ATIVIDADE_COLETIVA_ATIVIDADE_SAUDE_PATH,
  ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH,
  ATIVIDADE_COLETIVA_REUNIOES_PATH,
} from 'components/layout/SideMenu/SideMenuItems'
import { PecSwitch, PrivateRoute } from 'components/route'
import { useFlags } from 'config/useFlagsContext'
import { useClearStorageOnLeave } from 'hooks/useStorage'
import React from 'react'
import Permissions from 'types/Permissions'

import { AtividadeColetivaGruposRootView } from './grupos/AtividadeColetivaGruposRootView'
import { AtividadeColetivaReuniaoRootView } from './reuniao/AtividadeColetivaReuniaoRootView'
import { AtividadeColetivaSaudeRootView } from './saude/AtividadeColetivaSaudeRootView'

const ATIVIDADE_COLETIVA_FILTER_STORAGE_PATTERN = /atividade-coletiva-(grupos|reuniao|saude)-filter$/

export function AtividadeColetivaRootView() {
  const { ATIVIDADE_COLETIVA_ENABLED } = useFlags()

  useClearStorageOnLeave(ATIVIDADE_COLETIVA_FILTER_STORAGE_PATTERN)

  return (
    <PecSwitch>
      <PrivateRoute
        path={ATIVIDADE_COLETIVA_ATIVIDADE_SAUDE_PATH}
        component={AtividadeColetivaSaudeRootView}
        permission={Permissions.cds.fichaDeAtividadeColetiva}
      />
      <PrivateRoute
        path={ATIVIDADE_COLETIVA_REUNIOES_PATH}
        component={AtividadeColetivaReuniaoRootView}
        permission={Permissions.cds.fichaDeAtividadeColetiva}
      />
      {ATIVIDADE_COLETIVA_ENABLED && (
        <PrivateRoute
          path={ATIVIDADE_COLETIVA_GESTAO_GRUPOS_PATH}
          component={AtividadeColetivaGruposRootView}
          permission={Permissions.cds.fichaDeAtividadeColetiva}
        />
      )}
    </PecSwitch>
  )
}
